export default "__VITE_ASSET__9zH9Bm5e__"